import { render } from "./importKPIs.vue?vue&type=template&id=134c61bc&scoped=true&ts=true"
import script from "./importKPIs.vue?vue&type=script&lang=ts"
export * from "./importKPIs.vue?vue&type=script&lang=ts"

import "./importKPIs.vue?vue&type=style&index=0&id=134c61bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134c61bc"]])

export default __exports__